var _dark, _defineStyle;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// src/components/popover.ts
import { popoverAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/styled-system";
import { cssVar } from "@chakra-ui/theme-tools";

var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
    defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
    definePartsStyle = _createMultiStyleConf.definePartsStyle;

var $popperBg = cssVar("popper-bg");
var $arrowBg = cssVar("popper-arrow-bg");
var $arrowShadowColor = cssVar("popper-arrow-shadow-color");
var baseStylePopper = defineStyle({
  zIndex: 10
});
var baseStyleContent = defineStyle((_defineStyle = {}, _defineProperty(_defineStyle, $popperBg.variable, "colors.white"), _defineProperty(_defineStyle, "bg", $popperBg.reference), _defineProperty(_defineStyle, $arrowBg.variable, $popperBg.reference), _defineProperty(_defineStyle, $arrowShadowColor.variable, "colors.gray.200"), _defineProperty(_defineStyle, "_dark", (_dark = {}, _defineProperty(_dark, $popperBg.variable, "colors.gray.700"), _defineProperty(_dark, $arrowShadowColor.variable, "colors.whiteAlpha.300"), _dark)), _defineProperty(_defineStyle, "width", "xs"), _defineProperty(_defineStyle, "border", "1px solid"), _defineProperty(_defineStyle, "borderColor", "inherit"), _defineProperty(_defineStyle, "borderRadius", "md"), _defineProperty(_defineStyle, "boxShadow", "sm"), _defineProperty(_defineStyle, "zIndex", "inherit"), _defineProperty(_defineStyle, "_focusVisible", {
  outline: 0,
  boxShadow: "outline"
}), _defineStyle));
var baseStyleHeader = defineStyle({
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
});
var baseStyleBody = defineStyle({
  px: 3,
  py: 2
});
var baseStyleFooter = defineStyle({
  px: 3,
  py: 2,
  borderTopWidth: "1px"
});
var baseStyleCloseButton = defineStyle({
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
});
var baseStyle = definePartsStyle({
  popper: baseStylePopper,
  content: baseStyleContent,
  header: baseStyleHeader,
  body: baseStyleBody,
  footer: baseStyleFooter,
  closeButton: baseStyleCloseButton
});
var popoverTheme = defineMultiStyleConfig({
  baseStyle: baseStyle
});
export { popoverTheme };